import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hasura = defineConnector({
  identifier: "hasura",
  name: "Hasura",
  tagLine: "Instant GraphQL and REST APIs",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.hasura\\.app/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-Hasura-Admin-Secret",
        value: app.secret.adminSecret,
      },
    ]),
  steps: [
    {
      title: "Enter your Hasura instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-project.hasura.app",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your admin secret",
      items: [
        {
          kind: "markdown",
          content:
            "Find your Hasura admin secret in your project settings or environment configuration. See the [API docs](https://hasura.io/docs/latest/api-reference/) for details.",
        },
        {
          kind: "input",
          label: "Admin secret",
          required: true,
          target: { kind: "secrets", field: "adminSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/v1/metadata`,
  },
});
